import React, { ReactNode } from 'react';
import styled from 'styled-components';

// const BoxContainer = styled.div`
//     padding: 20px; /* Space inside the box */
//     border: 2px solid #ddd; /* Box border */
//     border-radius: 10px; /* Rounded corners */
//     background-color: #fff; /* Box background color */
//     box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Optional shadow for depth */
// `;

const BoxContainer = styled.div`
  padding: 20px;
  border: 1px solid #ddd;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
`;

interface BoxComponentProps {
    children: ReactNode;
}

const BoxComponent: React.FC<BoxComponentProps> = ({ children }) => {
    return <BoxContainer>{children}</BoxContainer>;
};

export default BoxComponent;
